import styled from "styled-components";
import {LobbyWrapperDefaultBox} from './lobby-wrapper.default.box';
import {LOBBY_PAGE} from '../../themes/css-global-classes';

export const LobbyWrapperCasino777Box = styled(LobbyWrapperDefaultBox)`
  &:before {
    background-size: cover;
    top: 0;
    height: 35rem;
  }

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding: 0;
    .${LOBBY_PAGE} & {
      &:before {
        display: block;
        opacity:1;
        top: 0;
      }
    }
  }
`